import type { SearchDataPort, SearchQuery, SearchResult } from '../domain/search'

const search = async (port: SearchDataPort, query: SearchQuery): Promise<SearchResult[]> => port.search(query)

export { search }
